import { render, staticRenderFns } from "./UpdatesView.vue?vue&type=template&id=30ad8db0&scoped=true"
import script from "./UpdatesView.vue?vue&type=script&lang=js"
export * from "./UpdatesView.vue?vue&type=script&lang=js"
import style0 from "./UpdatesView.vue?vue&type=style&index=0&id=30ad8db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ad8db0",
  null
  
)

export default component.exports